import { fn } from "@ember/helper";
import ConditionalLoadingSpinner from "discourse/components/conditional-loading-spinner";
import DButton from "discourse/components/d-button";
import LoadMore from "discourse/components/load-more";
import PluginOutlet from "discourse/components/plugin-outlet";
import ResponsiveTable from "discourse/components/responsive-table";
import TableHeaderToggle from "discourse/components/table-header-toggle";
import TextField from "discourse/components/text-field";
import UserInfo from "discourse/components/user-info";
import lazyHash from "discourse/helpers/lazy-hash";
import dAgeWithTooltip from "discourse/ui-kit/helpers/d-age-with-tooltip";
import { i18n } from "discourse-i18n";

const CircleRequests = <template>
  <section class="circles-requests-wrapper circles-tab-content">
    <div class="group-members-actions circles-members-actions">
      <TextField
        @value={{@controller.filterInput}}
        @placeholderKey={{@controller.filterPlaceholder}}
        class="circles-username-filter no-blur"
      />
    </div>

    {{#if @controller.hasRequesters}}
      <PluginOutlet
        @name="circle-requests-list"
        @outletArgs={{lazyHash
          loadMore=@controller.loadMore
          requesters=@model.requesters
          acceptRequest=@controller.acceptRequest
          undoAcceptRequest=@controller.undoAcceptRequest
          denyRequest=@controller.denyRequest
        }}
      >
        <LoadMore
          @selector=".directory-table .directory-table__cell"
          @action={{@controller.loadMore}}
        >
          <ResponsiveTable
            @className="group-members circles-members group-members__requests circles-members__requests"
          >
            <:header>
              <TableHeaderToggle
                @order={{@controller.order}}
                @asc={{@controller.asc}}
                @field="username_lower"
                @labelKey="username"
                @automatic={{true}}
                class="username"
              />
              <TableHeaderToggle
                @order={{@controller.order}}
                @asc={{@controller.asc}}
                @field="requested_at"
                @labelKey="discourse_circles.circle.requests.requested_at"
                @automatic={{true}}
              />
              <div
                class="directory-table__column-header group-request-reason__column-header"
              >
                {{i18n "discourse_circles.circle.requests.reason"}}
              </div>
              <div class="directory-table__column-header"></div>
            </:header>

            <:body>
              {{#each @model.requesters as |m|}}
                <div class="directory-table__row">
                  <div class="directory-table__cell group-member">
                    <UserInfo @user={{m}} @skipName={{@controller.skipName}} />
                  </div>

                  <div class="directory-table__cell">
                    <span class="directory-table__label">
                      <span>{{i18n "groups.member_requested"}}</span>
                    </span>
                    <span class="directory-table__value">
                      <span>{{dAgeWithTooltip
                          m.requested_at
                          format="medium"
                        }}</span>
                    </span>
                  </div>

                  <div
                    class="directory-table__cell group-request-reason__content"
                  >
                    <span class="directory-table__label">
                      <span>{{i18n "groups.requests.reason"}}</span>
                    </span>
                    <span class="directory-table__value">
                      {{m.reason}}
                    </span>
                  </div>

                  <div class="directory-table__cell group-accept-deny-buttons">
                    {{#if m.request_undone}}
                      {{i18n "discourse_circles.circle.requests.undone"}}
                    {{else if m.request_accepted}}
                      {{i18n "discourse_circles.circle.requests.accepted"}}
                      <DButton
                        @action={{fn @controller.undoAcceptRequest m}}
                        @label="discourse_circles.circle.requests.undo"
                      />
                    {{else if m.request_denied}}
                      {{i18n "discourse_circles.circle.requests.denied"}}
                    {{else}}
                      <DButton
                        @action={{fn @controller.acceptRequest m}}
                        @label="discourse_circles.circle.requests.accept"
                        class="btn-primary"
                      />
                      <DButton
                        @action={{fn @controller.denyRequest m}}
                        @label="discourse_circles.circle.requests.deny"
                        class="btn-danger"
                      />
                    {{/if}}
                  </div>
                </div>
              {{/each}}
            </:body>
          </ResponsiveTable>
        </LoadMore>
      </PluginOutlet>

      <ConditionalLoadingSpinner @condition={{@controller.loading}} />
    {{else}}
      <div>{{i18n "discourse_circles.circle.requests.empty"}}</div>
    {{/if}}
  </section>
</template>;

export default CircleRequests;
